import { makeAutoObservable, observable, action, computed, autorun, toJS } from 'mobx'

class BalanceStore {
    balance;
    demo;

    constructor() {
        this.realBalance = 0;
        this.demoBalance = 500000;
        this.demo = true;
        this.balance = this.demo ? this.demoBalance : 0;
    	makeAutoObservable(this);

    }

    updateBalance(amount) {
        this.balance = amount;
    }

    updateRealBalance(amount) {
        this.realBalance = amount;
    }

    updateDemoBalance(amount) {
        this.demoBalance = amount;
    }

    updateDemo(value) {
        this.demo = value;
    }

}

const balanceStore = new BalanceStore();

export default balanceStore;
export { BalanceStore };